import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoPermissionLabelComponent } from './no-permission-label.component';

@NgModule({
  declarations: [NoPermissionLabelComponent],
  imports: [CommonModule],
  exports: [NoPermissionLabelComponent],
})
export class NoPermissionLabelModule {}
